
import React from "react";
import { IconButton, Typography } from '@mui/material';
import DeleteForeverOutlinedIcon from "@mui/icons-material/DeleteForeverOutlined";


export const MakeHyperLink = (props: any) => {

    if(props.value === null || props.value === ""){
        return ""
    }
    else if(props.value === "NotSubmitted"){
        return "No Duc process started"
    }
    else if(props.value === "Pending NIDA approval"){
        return (
            <Typography fontSize="13px" color="blueviolet" sx={{ textDecoration: 'underline' }}>
                {
                /* Following ticket is responsible for the discrepancy of NIDA and DAC:
                https://lassoinformatics.atlassian.net/browse/LC-2092
                */
                }
              Pending DAC approval
            </Typography>
        )
    }
    else if (props?.data?.ducStatus === "TrainingComplete"){
        return "DUC and Training Complete"
    }
    else if (props.value === "Completed"){
        return "DUC Approved"
    }
    else{
        return props.value
    }


}

export const checkGroup = (props: any) => {
    if(props.data.roles.includes("PI") || props.data.signingUrl === "Subapplicant"){
        return "Investigator-led"
    }
    else{
        return "Individual"
    }

}


export const GetRevoked = (props: any) => {
    const row = props?.data
    return (
        <IconButton
            tabIndex={-1} //Prevents focus trap. User will be tabbing/arrow keying cells in aggrid.
            disabled={row?.ducStatus === 'NotSubmitted'}
            aria-label={`Revoke DUC for ${row?.email}`}
            aria-disabled={row?.ducStatus === 'NotSubmitted'}
        >
            <DeleteForeverOutlinedIcon/>
        </IconButton>
    )
}